import { render } from "./MainWithSmallSidebar.vue?vue&type=template&id=509c657b"
import script from "./MainWithSmallSidebar.vue?vue&type=script&lang=js"
export * from "./MainWithSmallSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__